import AnnotationsNormalizationPlugin from './AnnotationsNormalizationPlugin';
import TableOfContentsEnabledNormalizationPlugin from './TableOfContentsNormalization';

export default [
  AnnotationsNormalizationPlugin,
  TableOfContentsEnabledNormalizationPlugin,
];
